import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from "rxjs/Subject";
import { validateConfig } from '@angular/router/src/config';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { Globals } from '../../../global';

@Injectable()

export class PeticionesHttpBackEndService {
  public urlBack: string;
  public urlAction: string;
  public token: any;

  constructor(public _http: HttpClient, private router: Router){
   //this.urlBack = 'http://apilocal.com/api';//LOCAL
   //this.urlBack = 'http://127.0.0.1:80/api';//LOCAL
  //this.urlBack = 'http://preapi.intranetsedic.online/api';//PRE
  // this.urlBack = 'http://proapi.intranetsedic.online/api';//PRO
    this.urlBack = 'https://'+ Globals.DOMAIN_NAME +'/Bsedic/public/api';//PRO 2
    if (localStorage.getItem('auth_app_token')){
      this.token = JSON.parse(localStorage.getItem('auth_app_token'));
    }    
  }

  comprobarLogin(){
    return this.token != undefined ? true : false;
  }
  getAllReg(urlAction) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }


  getAllActividades(urlAction) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }
  getActividadesById(urlAction,actividadesById) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction+'/'+actividadesById,httpOptions);
  }

  getCaculoDatosActividades(urlAction,actividadesById) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction+'/'+actividadesById,httpOptions);
  }
  
  DownloadFileExcel(urlAction,formData){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.post(this.urlBack+'/'+urlAction,formData,httpOptions);
  }
  

  getAllTipologias(urlAction) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }

  getGenerico(urlAction) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }

  getMotivosBajas(urlAction) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }

  uploadFileActividades(formData, ActividadId, Editar){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.post(this.urlBack+"/v1/uploadFileActividades/"+ActividadId+"/"+Editar,formData, httpOptions);
  }

  uploadFile(formData){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.post(this.urlBack+"/v1/uploadFile",formData, httpOptions);
  }
  uploadImgPerfil(formData,entidadId){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
    return this._http.post(this.urlBack+"/v1/uploadImgPerfil/"+entidadId+"",formData, httpOptions);
  }
  uploadImgPublicaciones(formData,entidadId){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
    return this._http.post(this.urlBack+"/v1/uploadImgPublicaciones/"+entidadId+"",formData, httpOptions);
    }
  uploadFilePublicaciones(formData,entidadId){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
    return this._http.post(this.urlBack+"/v1/uploadFileMuros/"+entidadId+"",formData, httpOptions);
  }
  uploadFileId(formData,id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.post(this.urlBack+"/v1/uploadFileId/"+id+"",formData, httpOptions);
  }

  getOneReg(urlAction,id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction+'/'+id,httpOptions);
  }

  getOnePublic(urlAction,id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction+'/'+id,httpOptions);
  }

  getUsuario() {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/v1/usuarioLogueado',httpOptions);
  }

  updateOneReg(urlAction,id,data) {
    /* Actualiza un determinado registro en la base de datos */
    let respuesta: any;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.put(this.urlBack+'/'+urlAction+'/'+id, data, httpOptions);
  }

  insertObject(urlAction,id,data) {
    /* Actualiza un determinado registro en la base de datos */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.post(this.urlBack+'/'+urlAction+'/'+id, data, httpOptions);
  }

  checkToken() {
    /* Actualiza un determinado registro en la base de datos */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.get(this.urlBack+'/v1/checkToken', httpOptions);
  }

  checkRoles() {
    
    /* Actualiza un determinado registro en la base de datos */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.get(this.urlBack+'/v1/checkValidRol', httpOptions);
  }

  insertaObjecto(urlAction,data) {
    /* Actualiza un determinado registro en la base de datos */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.post(this.urlBack+'/'+urlAction+'', data, httpOptions);
  }

  postRequestPublic(urlAction,data) {
    /* Actualiza un determinado registro en la base de datos */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json'})
    };
    return this._http.post(this.urlBack+'/'+urlAction+'', data, httpOptions);
  }

  postRequest(urlAction,data) {
    /* Hace petición post */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+this.token.value+''})
    };
    return this._http.post(this.urlBack+'/'+urlAction+'', data, httpOptions);
  }

  postRequestPaypal(url,token,data) {
    /* Hace petición post */
    let resultado;
    let httpOptions = {
      headers: new HttpHeaders({'Content-Type':  'application/json','Authorization': 'Bearer '+token+''})
    };
    return this._http.post(url, data, httpOptions);
  }



  deleteOneReg(urlAction,id) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction+'/'+id,httpOptions);
  }

  deleteOneRegAsistentes(urlAction,data) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
    return this._http.post(this.urlBack+'/'+urlAction+'', data, httpOptions);
  }
  getAllPublic(urlAction) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
   return this._http.get(this.urlBack+'/'+urlAction,httpOptions);
  }

  postGeneralConParametro(urlAction,data) {
    /* Devuelve todos los registros que le pasa el back en la petición */
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer '+this.token.value+''
      })
    };
   return this._http.post(this.urlBack+'/'+urlAction+'', data, httpOptions);
  }
}
